import { type FC } from "react";
import { Chip, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { RefundStatusType } from "@/types/graphql/partner.generated";
import {
  type RefundStatusLike,
  refundStatusLabelKey,
} from "../model/refundStatus";

const STATUS_COLOR: Record<RefundStatusType, "default" | "success" | "error"> =
  {
    [RefundStatusType.PendingType]: "default",
    [RefundStatusType.SucceededType]: "success",
    [RefundStatusType.FailedType]: "error",
  };

export const RefundStatusChip: FC<{ refund: RefundStatusLike }> = ({
  refund,
}) => {
  const { t } = useTranslation();

  if (refund.manual) {
    return (
      <Tooltip title={t("refunds.manualTooltip")}>
        <Chip
          size="small"
          color="warning"
          label={t(refundStatusLabelKey(refund))}
        />
      </Tooltip>
    );
  }

  return (
    <Chip
      size="small"
      color={STATUS_COLOR[refund.status]}
      label={t(refundStatusLabelKey(refund))}
    />
  );
};
